export const FilterPanelPartition = 'filter-panel-partition';
